import React from "react";

export default ({ iconColor = "white", ...props }) => {
  return (
    <svg width={32} height={32} viewBox="0 0 21 15" fill="none" {...props}>
      <path
        d="M10.5 0C7.715 0 5.045.882 3.075 2.452 1.106 4.022 0 6.152 0 8.372c.003 1.444.474 2.863 1.367 4.119.894 1.256 2.18 2.306 3.734 3.049-.414.887-1.034 1.718-1.836 2.46 1.555-.261 3.014-.81 4.265-1.604a13 13 0 002.97.347c2.785 0 5.456-.882 7.425-2.452 1.969-1.57 3.075-3.7 3.075-5.92 0-2.22-1.106-4.349-3.075-5.919C15.955.882 13.285 0 10.5 0z"
        fill={iconColor}
      />
    </svg>
  );
};
